var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{attrs:{"alt":"Vue logo","src":require("../assets/logo.png")}}),_c('h1',[_vm._v("FHK Report Online Storage")]),_c('LocalCombine')],1)}
var staticRenderFns = []

export { render, staticRenderFns }